module.exports = __webpack_public_path__ + "img/peopleOutside1.265a4fc7.svg";